<template>
  <div class="task-caption">
    <div class="task-info pt-0 pb-3">
      <h3>{{ name }}｜{{ mission }}</h3>
    </div>
    <div v-for="(task, i) in studyTasks" :key="i" class="task-info">
      <div>
        <h6>{{ task.typeName }}</h6>
        <h4>{{ task.content }}</h4>
      </div>
      <h5 :class="{completed: task.isCompleted}">
        {{ task.isCompleted ? $t('已完成') : $t('尚未完成') }}
      </h5>
    </div>
  </div>
</template>

<script>
import academyService from '@/services/academy.js';
import studentInfoMixin from '@/mixin/studentInfo.js';
import studyTaskMixin from '@/mixin/studyTask.js';

export default {
  mixins: [studyTaskMixin, studentInfoMixin],
  props: {
    student: {
      type: Object,
      default: null,
    },
  },
  data() {
    return {
      studyTasks: [],
      username: '',
      currentBatch: 0,
    };
  },
  watch: {
    student: {
      handler() {
        this.getStudentStudyTask();
      },
      immediate: true,
    },
  },
  computed: {
    name() {
      return this.getName(this.student);
    },
    mission() {
      const currentBatch = this.currentBatch;
      const rank = this.getNewestMissionRank(this.student);
      const convertFunc = this.getConvertFunc({isGRank: true});
      return `${convertFunc(rank)}-${currentBatch}`;
    },
  },
  methods: {
    async getStudentStudyTask() {
      const student = this.student;
      if (!student?.username || this.username === student.username) return;
      this.username = student.username;
      await this.$store.commit('env/setIsLoading', true);
      try {
        const time = this.$day().format('YYYY-MM-DD HH');
        const studyTaskDocs = await academyService.getStudentStudyTask({
          username: student.username,
          time,
        });
        this.currentBatch = studyTaskDocs.currentBatch;
        this.studyTasks = studyTaskDocs.studyTasks.map((task) => {
          return {
            typeName: this.getTypeName(task),
            content: this.getContent(task),
            isCompleted: task.isCompleted,
          };
        });
      } catch (error) {
        console.error(error);
        this.$Message.error(this.$t('發生未知錯誤，再試一次'));
      }

      await this.$store.commit('env/setIsLoading', false);
    },
  },
};
</script>

<style lang="scss" scoped>
.task-caption {
  padding: $spacing-s;
  padding-bottom: 0;
}

.task-info {
  display: flex;
  padding: 8px 0px;
  align-items: center;
  gap: 16px;
  align-self: stretch;
  padding: 8px 0px;
  border-bottom: 1px solid $line-2;
  background: $white;
  justify-content: space-between;
  &:last-child {
    border-bottom: none;
  }
}
h6 {
  color: $font-grayscale-2;
}
h4 {
  color: $font-normal;
}
h5 {
  color: $font-third;
  &.completed {
    color: $font-grayscale-1;
  }
}
</style>
